import { Component } from '@angular/core'
import { ResetSentComponent } from '../../lib/reset-sent/reset-sent.component'

@Component({
  selector: 'ftr-reset-sent-page',
  template: '<ftr-reset-sent />',
  imports: [ResetSentComponent],
})
export class ResetSentPage {}
